import { render, staticRenderFns } from "./GoalsAndSynthesisTab.vue?vue&type=template&id=29f3a9e0&scoped=true"
import script from "./GoalsAndSynthesisTab.vue?vue&type=script&lang=js"
export * from "./GoalsAndSynthesisTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3a9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f3a9e0')) {
      api.createRecord('29f3a9e0', component.options)
    } else {
      api.reload('29f3a9e0', component.options)
    }
    module.hot.accept("./GoalsAndSynthesisTab.vue?vue&type=template&id=29f3a9e0&scoped=true", function () {
      api.rerender('29f3a9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/tabs/GoalsAndSynthesisTab.vue"
export default component.exports